/* eslint-disable new-cap */
import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import {connect} from 'react-redux';
import './styles.scss';
const VehicleForm = ({data}) => {
  const dollarUS = Intl.NumberFormat('de-DE');
  return (
    <>
      <Form size={'small'} className='form-floating-inventory form-floating-inventory-vehicle'>
        <div className='W-100 floating-inv-section-title'>
          C. DATOS DEL VEHÍCULO
        </div>
        <Grid
          stackable
          fluid
          columns={4}
          className="no-space spacing-form-fl-inventory temp-floating-vehicle"
          textAlign="left"
        >
          <Grid.Row className='floating-inventory-state-spacing-l1' columns={3}>
            <Grid.Column width={4}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="LÍNEA"
                placeholder=" - "
                value={data?.line}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="PEDIDO"
                placeholder=" - "
                value={data?.orderNumber}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="DESCRIPCIÓN"
                placeholder=" - "
                value={data?.description}
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='floating-inventory-state-spacing' columns={3}>
            <Grid.Column width={4}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="KATASHIKI"
                placeholder=" - "
                value={data?.katashiki}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={4}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="SFX"
                placeholder=" - "
                value={data?.sfx}
                readOnly
              />

            </Grid.Column>
            <Grid.Column width={8}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="CHASIS"
                placeholder=" - "
                value={data?.chassis}
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='floating-inventory-state-spacing' columns={3}>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="MOTOR"
                placeholder=" - "
                value={data?.motor}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="CÓDIGO EXTERIOR"
                placeholder=" - "
                value={data?.externalColorId}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="COLOR EXTERIOR"
                placeholder=" - "
                value={data?.externalColor}
                readOnly
              />

            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='floating-inventory-state-spacing' columns={3}>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="CÓDIGO INTERIOR"
                placeholder=" - "
                value={data?.internalColorId}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="COLOR INTERIOR"
                placeholder=" - "
                value={data?.internalColor}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="AÑO MODELO"
                placeholder=" - "
                value={data?.yearModel}
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={3}>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="VALOR FOB"
                placeholder=" - "
                value={data?.fobValue ? `$ ${dollarUS.format(data?.fobValue)}` : ''}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="FECHA DE LLEGADA"
                placeholder=" - "
                value={data?.arrivalDate?.substring(0, 10)}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="UBICACIÓN"
                placeholder=" - "
                value={data?.locationText}
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='floating-inventory-state-last' columns={2}>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="FECHA DE INGRESO A DEPÓSITO"
                placeholder=" - "
                value={data?.depositDate ? data?.depositDate?.substring(0, 10) : ''}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={5}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="DÍAS EN DEPÓSITO"
                placeholder=" - "
                value={data?.daysInDeposit?.split('/')[0]}
                readOnly
              />
            </Grid.Column>
            <Grid.Column width={6}>
              <Form.Input
                className='small-label-custom'
                size='mini'
                label="IMPORTADOR"
                placeholder=" - "
                value={data?.importerName}
                readOnly
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'listDealers': state.dealer.list,
  };
};

export default connect(mapStateToProps, {})(VehicleForm);
